import type * as Types from '@trello/graphql/generated';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import type { tag } from '@trello/utility-types';
import * as Apollo from '@apollo/client';
import process from 'process';
export type __OpaqueBrandRef = typeof tag;
export type TrelloQuickCaptureNotificationFieldsFragment = (
  { __typename: 'TrelloQuickCaptureNotification' }
  & Pick<Types.TrelloQuickCaptureNotification, 'id'>
  & { card?: Types.Maybe<(
    { __typename: 'TrelloQuickCaptureCard' }
    & Pick<Types.TrelloQuickCaptureCard, 'id'>
  )> }
);

export const TrelloQuickCaptureNotificationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TrelloQuickCaptureNotificationFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloQuickCaptureNotification' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'card' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TrelloQuickCaptureNotificationFieldsFragment,
  unknown
>;

interface UseTrelloQuickCaptureNotificationFieldsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      TrelloQuickCaptureNotificationFieldsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: (Apollo.StoreObject | Apollo.Reference) | null;
  returnPartialData?: boolean;
}

interface UseTrelloQuickCaptureNotificationFieldsFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<TrelloQuickCaptureNotificationFieldsFragment>,
    'data'
  > {
  data?: TrelloQuickCaptureNotificationFieldsFragment;
}

export const useTrelloQuickCaptureNotificationFieldsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseTrelloQuickCaptureNotificationFieldsFragmentOptions): UseTrelloQuickCaptureNotificationFieldsFragmentResult => {
  const result =
    Apollo.useFragment<TrelloQuickCaptureNotificationFieldsFragment>({
      ...options,
      fragment: TrelloQuickCaptureNotificationFieldsFragmentDoc,
      fragmentName: 'TrelloQuickCaptureNotificationFields',
      from:
        !from || !(from as Apollo.StoreObject)?.id
          ? null
          : { __typename: 'TrelloQuickCaptureNotification', ...from },
    });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as TrelloQuickCaptureNotificationFieldsFragment,
  };
};
